// Library imports
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import store, { RootState } from "store";
import styled from "styled-components";
import Carousel from "react-multi-carousel";
import { Popover } from "antd";

// Local imports
import ListCard from "../../Shared/ListCard";
import GenericSearch from "modules/Campaigns/Shared/GenericSearch";
import PersonBadgeItem from "./PersonBadgeItem";
import ButtonRightIconGreen from "../../../Common/Components/ButtonRightIconGreen";
import ButtonRightIcon from "../../../Common/Components/ButtonRightIcon";
import DoneGreen from "../../../../assets/img/icons/tick-white.svg";
import ExportIconV2 from "../../../../assets/img/icons/ExportIconV2.svg";
import Send from "../../../../assets/img/icons/Send.svg";
import Info from "../../../../assets/img/icons/Info.svg";
import Checkbox from "../../../Common/Components/Checkbox";

import {
  searchPeople,
  searchLists,
  clearPeopleSearch,
  clearListSearch,
  dynamicAudienceSearch,
  resetSelectAllRecommendedContacts,
  getRecommendedPeople,
  recommendedPeopleExport,
  setSelectedUnSelectAllRecommendedContacts,
  setSelectedUnSelectAllRecommendedDynamicContacts,
  setSelectedUnSelectAllRecommendedSearchedContacts,
} from "../actions";
import {
  DYNAMIC_AUDIENCE_MATCHING,
  RECOMMENDED_LIST_SEARCH,
  RECOMMENDED_PEOPLE_SEARCH,
} from "constants/actionTypes";
import { getQueryListId } from "utils";
import InfiniteLoader from "modules/Common/Components/InfiniteLoader";
import RecommendedContactLoader from "modules/Common/Components/RecommendedContactLoader";
import { SELECTED_RECOMMENDED_LISTS } from "constants/types";
import GeneralExportPopup from "modules/Campaigns/Audience/Components/GeneralExportPopup";
import AssetsFourCardsPlaceHolder from "modules/Campaigns/AssetsWithOutCampaigns/Components/AssetFourCardsPlaceHolder";
import TotalCountLoader from "modules/Common/Components/TotalCountLoader";

interface IPeopleAndListProps {
  onClickAudienceDone?: any;
  handleAddPeople?: any;
  selectedContactIds?: number[];
  selectedListIds?: number[];
  addedContactIds?: number[];
  addedListIds?: number[];
  hideRecommendedList?: boolean;
  isPersonAdded?: any;
  enableScrollForContacts?: boolean;
  disableMaxHeight?: boolean;
  inContactList?: boolean;
  inCreateCampaign?: boolean;
  inPublish?: boolean;
  inCreateNewList?: boolean;
  selectAllFlag?: boolean;
  unselectedContactIdsState?: string[];
  isOpened?: boolean;
  idForPagination?: string;
}

const PeopleAndList: React.FC<IPeopleAndListProps> = ({
  onClickAudienceDone,
  handleAddPeople,
  selectedContactIds = [],
  selectedListIds = [],
  addedContactIds = [],
  addedListIds = [],
  hideRecommendedList = false,
  isPersonAdded,
  enableScrollForContacts,
  disableMaxHeight,
  inCreateNewList,
  selectAllFlag,
  unselectedContactIdsState,
  isOpened,
  idForPagination,
}) => {
  // hide select all
  const hideSelectAll = true;

  //Local States
  const [dynamicKeywordsState, setDynamicKeywordsState] = useState<string[]>([]);
  const [dynamicPeopleMode, setDynamicPeopleMode] = useState(false);
  const [searchPeopleMode, setSearchPeopleMode] = useState(false);
  const [searchListMode, setSearchListMode] = useState(false);
  const [searchedPeopleData, setSearchedPeopleData] = useState<any>([]);
  const [dynamicPeopleData, setDynamicPeopleData] = useState<any>([]);
  const [recommendedPeopleData, setRecommendedPeopleData] = useState<any>([]);
  const [skipFirstMount, setSkipFirstMount] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectAllSearchedContacts, setSelectAllSearchedContacts] = useState(false);
  const [selectAllDynamicContacts, setSelectAllDynamicContacts] = useState(false);
  const [selectAllLists, setSelectAllLists] = useState(false);
  const [searchTermLists, setSearchTermLists] = useState("");
  const [searchTermContacts, setSearchTermContacts] = useState("");

  // exporting popup
  const [exportLoading, setExportLoading] = useState(false);
  const [showExportPopup, setShowExportPopup] = useState(false);
  const [showExportError, setExportError] = useState(false);

  // Redux States
  const exportEmail = useSelector((state: RootState) => state.user.userData.userEmail);
  const recommendedAudienceList = useSelector((state: RootState) => state.recommendedLists.data);
  const recommendedAudienceTotalLists = useSelector((state: RootState) => state.recommendedLists.totalLists);
  const recommendedListsLoading = useSelector((state: RootState) => state.recommendedLists.loading);
  const recommendedAudienceContact = useSelector((state: RootState) => state.recommendedPeople.data);
  const recommendedAudienceTotalContacts = useSelector(
    (state: RootState) => state.recommendedPeople.totalContacts
  );
  const recommendedContactsLoading = useSelector((state: RootState) => state.recommendedPeople.loading);
  const peopleSearchResults = useSelector((state: RootState) => state.searchRecommendedPeople.data);
  const peopleSearchLoading = useSelector((state: RootState) => state.searchRecommendedPeople.loading);
  const peopleSearchSuccess = useSelector((state: RootState) => state.searchRecommendedPeople.success);
  const peopleSearchMessage = useSelector((state: RootState) => state.searchRecommendedPeople.message);
  const peopleSearchTotalContacts = useSelector(
    (state: RootState) => state.searchRecommendedPeople.totalSearchedContacts
  );

  const listSearchResults = useSelector((state: RootState) => state.searchRecommendedList.data);
  const listSearchTotalResults = useSelector((state: RootState) => state.searchRecommendedList.totalLists);
  const listSearchLoading = useSelector((state: RootState) => state.searchRecommendedList.loading);
  const listSearchSuccess = useSelector((state: RootState) => state.searchRecommendedList.success);
  const listSearchMessage = useSelector((state: RootState) => state.searchRecommendedList.message);
  const dynamicKeywords = useSelector((state: RootState) => state.recommendedPeople.dynamicKeywords);
  const dynamicAudienceData = useSelector((state: RootState) => state.recommendedPeople.dynamicAudienceData);
  const dynamicAudienceTotalContacts = useSelector(
    (state: RootState) => state.recommendedPeople.dynamicAudienceTotalContacts
  );
  const dynamicAudienceLoading = useSelector((state: RootState) => state.recommendedPeople.dynamicAudienceLoading);
  const closeCreateNewListAsiderCheck = useSelector(
    (state: RootState) => state.uiReducer.closeCreateNewListAsiderCheck
  );
  const closeCreateNewListAsiderFromCancelCheck = useSelector(
    (state: RootState) => state.uiReducer.closeCreateNewListAsiderFromCancelCheck
  );
  const alreadySelectedContacts = useSelector(
    (state: RootState) => state.recommendedPeople.alreadySelectedContacts
  ); // this state contains the ids of the contacts that are already selected when creating new list
  const searchTerm = useSelector((state: RootState) => state.recommendedPeople.searchTerm);
  const audienceFiltersApplied: boolean = useSelector(
    (state: RootState) => state.uiReducer.audienceFiltersApplied
  );

  // ************************************************************************************************
  // * new reducer setup for selected contacts in recommended people/audience                       *
  // ************************************************************************************************
  const selectedRecommendedContacts = useSelector(
    (state: RootState) => state.recommendedPeople.selectedRecommendedContacts
  );
  // const selectedRecommendedContactsIds = useSelector((state: RootState) => state.recommendedPeople.selectedRecommendedContactsIds);
  const selectedRecommendedContactsIds = useSelector(
    (state: RootState) => state.selectedRecommendedContacts.selectedContactsIds
  );

  // Local Variables
  const responsiveV = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 2501 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 2500, min: 1476 },
      items: 4,
    },
    mindesktoplg: {
      breakpoint: { max: 1475, min: 1251 },
      items: 3,
    },
    mindesktop: {
      breakpoint: { max: 1250, min: 1025 },
      items: 2,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  const ContactsLoading = dynamicAudienceLoading || recommendedContactsLoading || peopleSearchLoading; // this const will be true if any of the loading states are true

  // Component Logic
  useEffect(() => {
    return () => {
      setSearchPeopleMode(false);
      setSearchListMode(false);
      setSearchTermLists('');
      setSearchTermContacts('');
    };
  }, []);

  useEffect(() => {
    // console.log("setSearchPeopleMode: 1");
    if (searchPeopleMode) {
      setSearchPeopleMode(false);
    }
  }, [closeCreateNewListAsiderCheck, closeCreateNewListAsiderFromCancelCheck]);

  useEffect(() => {
    if (skipFirstMount) {
      if (dynamicKeywords && dynamicKeywords?.length > 0) {
        setDynamicKeywordsState(dynamicKeywords);
        setDynamicPeopleMode(true);
        setSearchPeopleMode(false);
      } else {
        setDynamicKeywordsState([]);
        setDynamicPeopleMode(false);
        if (searchTerm?.length === 0) {
          setSearchPeopleMode(false);
        } else {
          setSearchPeopleMode(true);
          // keeping searchTerm local state in sync with redux state
          // if (!searchTermLists) {
          //   setSearchTermContacts(searchTerm);
          // }
          searchPeople(
            0,
            50,
            searchTerm,
            false,
            selectAllFlag,
            getQueryListId.toString(),
            unselectedContactIdsState
          );
        }
      }
    } else {
      setSkipFirstMount(true);
    }
  }, [dynamicKeywords, skipFirstMount]);

  useEffect(() => {
    if (searchPeopleMode && peopleSearchResults.length > 0) {
      const searchedPeopleDataHelper: any = peopleSearchResults.filter((item: any) => {
        // remove already selected people from searched audience results
        if (!alreadySelectedContacts.includes(item.id)) return item;
      });
      setSearchedPeopleData(searchedPeopleDataHelper);
    } else {
      setSearchedPeopleData([]);
    }
  }, [peopleSearchResults, searchPeopleMode]);

  useEffect(() => {
    if (dynamicPeopleMode && dynamicAudienceData.length > 0) {
      const dynamicPeopleDataHelper: any = dynamicAudienceData.filter((item: any) => {
        // remove already selected people from dynamic audience results
        if (!alreadySelectedContacts.includes(item.id)) return item;
      });
      setDynamicPeopleData(dynamicPeopleDataHelper);
    } else {
      setDynamicPeopleData([]);
    }
  }, [dynamicAudienceData, dynamicPeopleMode]);

  useEffect(() => {
    if (recommendedAudienceContact.length > 0) {
      const recommendedPeopleDataHelper: any = recommendedAudienceContact.filter((item: any) => {
        // remove already selected people from recommended audience results
        if (!alreadySelectedContacts.includes(item.id)) return item;
      });
      setRecommendedPeopleData(recommendedPeopleDataHelper);
    } else {
      setRecommendedPeopleData([]);
    }
  }, [recommendedAudienceContact, isOpened]);

  useEffect(() => {
    let recommendedPeopleDataWithoutAlreadySelected: any = recommendedPeopleData.filter(
      (item: any) => !alreadySelectedContacts.includes(item.id)
    );
    let selectedRecommendedContactsIdsWithoutAlreadySelected: any = selectedRecommendedContactsIds.filter(
      (item: any) => !alreadySelectedContacts.includes(item)
    );
    if (
      recommendedPeopleDataWithoutAlreadySelected.length > 0 ||
      selectedRecommendedContactsIdsWithoutAlreadySelected.length > 0
    ) {
      setSelectAll(
        recommendedPeopleDataWithoutAlreadySelected.length ===
        selectedRecommendedContactsIdsWithoutAlreadySelected.length
      );
    }
  }, [recommendedPeopleData, selectedRecommendedContactsIds, selectedContactIds]);

  function searchHandler(value: string, searchType: string) {
    if (value.length > 0) {
      if (dynamicKeywordsState.length > 0) {
        if (searchType === "contact") {
          dynamicAudienceSearch(
            0,
            50,
            value,
            dynamicKeywords?.join(","),
            selectAllFlag,
            getQueryListId.toString(),
            unselectedContactIdsState
          );
          setSearchTermContacts(value);
          // setSearchPeopleMode(true);
          store.dispatch({
            type: DYNAMIC_AUDIENCE_MATCHING.SEARCH_TERM,
            searchTerm: value,
          });
        } else if (searchType === "list") {
          setSearchListMode(true);
          setSearchTermLists(value);
          clearListSearch();
          searchLists(value, false);
        }
      } else {
        if (searchType === "contact") {
          setSearchTermContacts(value);
          setSearchPeopleMode(true);
          setDynamicPeopleMode(false);
          searchPeople(0, 70, value, false, selectAllFlag, getQueryListId.toString(), unselectedContactIdsState);
          store.dispatch({
            type: DYNAMIC_AUDIENCE_MATCHING.SEARCH_TERM,
            searchTerm: value,
          });
        } else if (searchType === "list") {
          setSearchListMode(true);
          setSearchTermLists(value);
          clearListSearch();
          searchLists(value, false);
        }
      }
    } else {
      if (searchType === "contact") {
        setSearchTermContacts(value);
        clearPeopleSearch();
        setSearchPeopleMode(false);
        setDynamicPeopleMode(false);
      } else if (searchType === "list") {
        setSearchListMode(true);
        setSearchTermLists(value);
        clearListSearch();
        searchLists(value, false);
      }
    }
  }

  function handleCancelPeopleSearch() {
    if (dynamicKeywordsState.length > 0) {
      if (searchTerm.length > 0) {
        dynamicAudienceSearch(
          0,
          50,
          "",
          dynamicKeywords?.join(","),
          selectAllFlag,
          getQueryListId.toString(),
          unselectedContactIdsState
        );
        store.dispatch({
          type: DYNAMIC_AUDIENCE_MATCHING.SEARCH_TERM,
          searchTerm: "",
        });
        setSearchPeopleMode(false);
        setDynamicPeopleMode(true);
      }
    } else {
      setSearchPeopleMode(false);
      setDynamicPeopleMode(false);
      setSearchTermContacts("");
      clearPeopleSearch();
    }
    store.dispatch({
      type: RECOMMENDED_PEOPLE_SEARCH.ERROR_SEARCH_TERM,
      message: "",
      success: true,
    });
  }

  function handleCancelListSearch() {
    // console.log('handleCancelListSearch', 'handleCancelListSearch');
    // console.log('setSearchListMode: ', searchListMode);
    if (searchListMode) {
      setSearchListMode(false);
      setSearchTermLists("");
      clearListSearch();
      console.log('inside if')
      store.dispatch({
        type: RECOMMENDED_LIST_SEARCH.ERROR_SEARCH_TERM,
        message: "",
        success: true,
      });
      if (dynamicKeywordsState.length > 0) {
        searchLists(dynamicKeywordsState.toString(), true);
      }
    }
  }

  function handleDynamicAudienceSearchPagination(reset?: boolean, limit?: number, selectAll?: boolean) {
    dynamicAudienceSearch(
      reset ? 0 : dynamicAudienceData.length,
      50,
      searchTerm,
      dynamicKeywords?.join(","),
      selectAllFlag,
      getQueryListId.toString(),
      unselectedContactIdsState,
      selectAll // flag for select All
    );
  }

  function handleRecommendedAudiencePagination(reset?: boolean, limit?: number, selectAll?: boolean) {
    getRecommendedPeople(
      reset ? 0 : recommendedAudienceContact.length,
      limit ? limit : 50,
      false,
      "",
      [],
      selectAll // flag for select all
    );
    // if (selectAll) {
    // } else {
    //   getRecommendedPeople(
    //     reset ? 0 : recommendedAudienceContact.length,
    //     limit ? limit : 50,
    //   );
    // }
  }

  function handleRecommendedAudienceSearchPagination(reset?: boolean, limit?: number, selectAll?: boolean) {
    searchPeople(
      reset ? 0 : peopleSearchResults.length,
      limit ? limit : 50,
      searchTerm,
      false,
      selectAllFlag,
      getQueryListId.toString(),
      unselectedContactIdsState,
      selectAll // flag for select All
    );
  }

  function handleNext() {
    // console.log("handleNext");
    // console.log("searchPeopleMode", searchPeopleMode);
    // console.log("dynamicPeopleMode", dynamicPeopleMode);
    if (!searchPeopleMode && !dynamicPeopleMode) {
      handleRecommendedAudiencePagination();
    } else if (dynamicPeopleMode && !searchPeopleMode) {
      handleDynamicAudienceSearchPagination();
    } else if (!dynamicPeopleMode && searchPeopleMode) {
      handleRecommendedAudienceSearchPagination();
    }
  }

  const handleSelectAll = (event: any) => {
    let checked = event?.target?.checked;
    if (checked) {
      if (!searchPeopleMode && !dynamicPeopleMode) {
        setSelectAll(checked);
        handleRecommendedAudiencePagination(
          false,
          recommendedAudienceTotalContacts - recommendedAudienceContact.length,
          true
        );
      } else if (dynamicPeopleMode && !searchPeopleMode) {
        setSelectAllDynamicContacts(checked);
        handleDynamicAudienceSearchPagination(
          false,
          dynamicAudienceTotalContacts - dynamicAudienceData.length,
          true
        );
      } else if (!dynamicPeopleMode && searchPeopleMode) {
        setSelectAllSearchedContacts(checked);
        handleRecommendedAudienceSearchPagination(
          false,
          peopleSearchTotalContacts - searchedPeopleData.length,
          true
        );
      }
    } else {
      if (!searchPeopleMode && !dynamicPeopleMode) {
        setSelectAll(checked);
        resetSelectAllRecommendedContacts();
        setSelectedUnSelectAllRecommendedContacts();
      } else if (dynamicPeopleMode && !searchPeopleMode) {
        setSelectAllDynamicContacts(checked);
        setSelectedUnSelectAllRecommendedDynamicContacts();
      } else if (!dynamicPeopleMode && searchPeopleMode) {
        setSelectAllSearchedContacts(checked);
        setSelectedUnSelectAllRecommendedSearchedContacts();
      }
    }
  };

  const handleSelectAllLists = (event: any) => {
    let checked = event?.target?.checked;
    setSelectAllLists(checked);
    if (checked) {
      store.dispatch({
        type: SELECTED_RECOMMENDED_LISTS.SET_SELECT_ALL,
        selectedLists: recommendedAudienceList,
        isSelectAll: true,
      });
    } else {
      store.dispatch({
        type: SELECTED_RECOMMENDED_LISTS.RESET_SELECT_ALL,
      });
    }
  };

  const totalCount = () => {
    let total =
      !searchPeopleMode && !dynamicPeopleMode
        ? recommendedAudienceTotalContacts
        : dynamicPeopleMode && !searchPeopleMode
          ? dynamicAudienceTotalContacts
          : !dynamicPeopleMode && searchPeopleMode
            ? peopleSearchTotalContacts
            : 0;

    if (alreadySelectedContacts?.length > 0) {
      if (!searchPeopleMode && !dynamicPeopleMode) {
        total = recommendedAudienceTotalContacts -
          recommendedAudienceContact.filter((item: any) => alreadySelectedContacts.includes(item.id)).length;
      } else if (dynamicPeopleMode && !searchPeopleMode) {
        total = dynamicAudienceTotalContacts - dynamicAudienceData.filter((item: any) => alreadySelectedContacts.includes(item.id)).length;
      } else if (!dynamicPeopleMode && searchPeopleMode) {
        total = peopleSearchTotalContacts - searchedPeopleData.filter((item: any) => alreadySelectedContacts.includes(item.id)).length;
      }
    }
    if (total < 0) {
      total = 0;
    }

    return total;
  };

  const totalSelectedContacts = () => {
    let total =
      !searchPeopleMode && !dynamicPeopleMode
        ? recommendedAudienceContact.filter((item: any) => selectedContactIds.includes(item.id)).length
        : dynamicPeopleMode && !searchPeopleMode
          ? dynamicAudienceData.filter((item: any) => selectedContactIds.includes(item.id)).length
          : !dynamicPeopleMode && searchPeopleMode
            ? searchedPeopleData.filter((item: any) => selectedContactIds.includes(item.id)).length
            : 0;

    return total;
  };

  useEffect(() => {
    if (!searchPeopleMode && !dynamicPeopleMode) {
      // console.log("useEffect setSelectAll Searched");
      recommendedAudienceContact.filter((item: any) => selectedContactIds.includes(item.id)).length ===
        recommendedAudienceContact.length && recommendedAudienceContact.length !== 0
        ? setSelectAll(true)
        : setSelectAll(false);
    } else if (!searchPeopleMode && dynamicPeopleMode) {
      // console.log("useEffect setSelectAll DynamicContacts");
      dynamicAudienceData.filter((item: any) => selectedContactIds.includes(item.id)).length ===
        dynamicAudienceData.length && dynamicAudienceData.length !== 0
        ? setSelectAllDynamicContacts(true)
        : setSelectAllDynamicContacts(false);
    } else if (searchPeopleMode && !dynamicPeopleMode) {
      // console.log("useEffect setSelectAll RecommendedContacts");
      searchedPeopleData.filter((item: any) => selectedContactIds.includes(item.id)).length ===
        searchedPeopleData.length && searchedPeopleData.length !== 0
        ? setSelectAllSearchedContacts(true)
        : setSelectAllSearchedContacts(false);
    }
  }, [
    dynamicPeopleMode,
    searchPeopleMode,
    searchedPeopleData,
    dynamicAudienceData,
    recommendedAudienceContact,
    selectedContactIds,
  ]);

  const totalCountLists = () => {
    let total = searchListMode ? listSearchTotalResults : recommendedAudienceTotalLists;

    return total;
  };

  const handleClickDone = () => {
    if (searchListMode) {
      handleCancelListSearch();
      setSearchTermLists("");
    }
    if (searchPeopleMode) {
      handleCancelPeopleSearch();
      setSearchTermContacts("");
    }
    if (onClickAudienceDone) onClickAudienceDone();
  };

  const handleExportContacts = () => {
    if (
      (!searchPeopleMode && dynamicPeopleMode && dynamicAudienceData.length === 0) ||
      (searchPeopleMode && !dynamicPeopleMode && searchedPeopleData.length === 0) ||
      (!searchPeopleMode && !dynamicPeopleMode && recommendedAudienceContact.length === 0) ||
      ContactsLoading
    ) {
      return;
    }
    setExportLoading(true);
    recommendedPeopleExport(searchTerm, dynamicKeywords?.toString())
      .then((res) => {
        if (res?.data?.success) {
          setExportLoading(false);
          setShowExportPopup(true);
          setExportError(false);
        } else {
          setExportLoading(false);
          setShowExportPopup(true);
          setExportError(true);
        }
      })
      .catch((err) => {
        console.log("error: ", err);
        setExportLoading(false);
        setShowExportPopup(true);
        setExportError(true);
      });
  };

  const ContactsLoader = [1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
    <RecommendedContactLoader key={`recommended-contacts-loading-${item}`} />
  ));

  // total count of contacts
  let totalCountContacts = totalCount();

  console.log('Test console')
  return (
    <Wrapper displayScroll={`${enableScrollForContacts ? "" : "none"}`} disableMaxHeight={disableMaxHeight}>
      <GeneralExportPopup
        showPopup={showExportPopup}
        showErrorPopup={showExportError}
        exportEmail={exportEmail}
        resendEmail={handleExportContacts}
        onClosePopup={() => {
          setShowExportPopup(false);
          setExportError(false);
        }}
      />
      <div className="head-wrapper recommended-contacts-row">
        <h3 className="heading heading-side-span">
          Recommended Contacts{" "}
          {(dynamicAudienceLoading && dynamicAudienceData.length === 0) ||
            (peopleSearchLoading && searchedPeopleData.length === 0) ||
            (recommendedContactsLoading && recommendedPeopleData.length === 0) ? (
            <TotalCountLoader />
          ) : (
            `(${totalCountContacts})`
          )}
          <span className="infoTooltip">
            <Popover
              trigger="hover"
              placement="bottom"
              overlayClassName="info-tooltip info-data-tooltip"
              content="Recommended Contacts is a dynamic feature that analyzes the intent of your email and suggests contacts with aligned interests, making it easier for you to connect with like-minded individuals."
            >
              <img src={Info} alt="info-icon" className="info-icon" />
            </Popover></span>
        </h3>
        <span className="d-flex flex-nowrap other-side">
          {/* <ButtonRightIcon
            label=""
            disable={exportLoading}
            icon={Send}
            outlineClass="auto-width me-3"
            onClick={handleExportContacts}
          /> */}
          <ExportBtn
            className={`exportBtn ${(!searchPeopleMode && dynamicPeopleMode && dynamicAudienceData.length === 0) ||
              (searchPeopleMode && !dynamicPeopleMode && searchedPeopleData.length === 0) ||
              (!searchPeopleMode && !dynamicPeopleMode && recommendedAudienceContact.length === 0) ||
              ContactsLoading
              ? "disable"
              : ""
              }`}
            onClick={handleExportContacts}
          >
            <img className="export-icon" src={ExportIconV2} alt="ExportIcon" />
          </ExportBtn>
          <div className="search-wrapper">
            <GenericSearch
              handleSearch={(value: string) => {
                searchHandler(value, "contact");
              }}
              outerValue={searchTermContacts}
              handleClear={handleCancelPeopleSearch}
              placeholder="Search contacts..."
              className="search-wrapper-two"
            />
          </div>
        </span>
      </div>

      <div className="d-flex flex-nowrap select-row">
        {hideSelectAll ? null : ((!searchPeopleMode && dynamicPeopleMode && dynamicAudienceData.length === 0) ||
          (searchPeopleMode && !dynamicPeopleMode && searchedPeopleData.length === 0) ||
          recommendedAudienceContact.length === 0) &&
          ContactsLoading ? null : (
          <>
            <label>
              <Checkbox
                checked={
                  !searchPeopleMode && dynamicPeopleMode
                    ? selectAllDynamicContacts
                    : !dynamicPeopleMode && searchPeopleMode
                      ? selectAllSearchedContacts
                      : selectAll
                }
                onChange={handleSelectAll}
              />
              {!searchPeopleMode && dynamicPeopleMode
                ? selectAllDynamicContacts
                  ? `Unselect all`
                  : `Select all`
                : !dynamicPeopleMode && searchPeopleMode
                  ? selectAllSearchedContacts
                    ? `Unselect all`
                    : `Select all`
                  : selectAll
                    ? `Unselect all`
                    : `Select all`}
            </label>
            {totalSelectedContacts() > 0 ? (
              <div className="selected-count">
                <Checkbox checked readOnly />
                <Checkbox checked readOnly />
                {totalSelectedContacts()} contacts selected
                {/* {selectedContactIds.filter(contact => !alreadySelectedContacts.includes(contact)).length} people selected */}
              </div>
            ) : null}
          </>
        )}
      </div>
      <div
        id={`recommended-people`}
        className={`contactsStyles ${hideRecommendedList ? "recommended-people full-height-users" : "recommended-people"
          }`}
      >
        {/* {ContactsLoading ? <p>Loading...</p> : null} */}
        {((!searchPeopleMode && dynamicPeopleMode && dynamicAudienceData.length === 0) ||
          (searchPeopleMode && !dynamicPeopleMode && searchedPeopleData.length === 0) ||
          (!searchPeopleMode && !dynamicPeopleMode && recommendedAudienceContact.length === 0)) &&
          ContactsLoading
          ? ContactsLoader
          : null}
        <InfiniteLoader
          dataLength={
            !searchPeopleMode && dynamicPeopleMode
              ? dynamicAudienceData.length
              : searchPeopleMode && !dynamicPeopleMode
                ? searchedPeopleData.length
                : recommendedAudienceContact.length
          }
          next={handleNext}
          hasMore={
            !searchPeopleMode && dynamicPeopleMode
              ? dynamicAudienceTotalContacts > dynamicAudienceData.length
              : searchPeopleMode && !dynamicPeopleMode
                ? peopleSearchTotalContacts > searchedPeopleData.length
                : recommendedAudienceTotalContacts > recommendedAudienceContact.length
          }
          loader={ContactsLoading ? ContactsLoader : ContactsLoader}
          height="auto"
        >
          {dynamicPeopleMode
            ? dynamicPeopleData.length > 0
              ? dynamicPeopleData?.map((contactItem: any) => (
                <PersonBadgeItem
                  key={`dynamic-${contactItem.id}`}
                  email={contactItem.email}
                  contact_id={contactItem.id}
                  image={contactItem.thumbnail ? contactItem.thumbnail : ""}
                  personalityType={contactItem.personality_details.archetype}
                  userName={contactItem.name.trim() || contactItem.email.trim()}
                  pColor={contactItem.personality_details.color}
                  handleAddPeople={handleAddPeople}
                  // selectedRecommendedContactsIds
                  // disabled={selectedContactIds?.indexOf(contactItem.id) >= 0 ? true : false}
                  // disabled={selectedContactIds?.indexOf(contactItem.id) >= 0 ? true : false}
                  added={addedContactIds?.indexOf(contactItem.id) >= 0}
                  selected={selectedContactIds?.indexOf(contactItem.id) >= 0}
                  organization={contactItem?.organization}
                  designation={contactItem?.designation}
                  status={contactItem?.status}
                  isBounced={contactItem?.status === "Hard Bounce" || contactItem?.status === "Unsubscribed"}
                  showTip
                  isDynamic
                />
              ))
              : !ContactsLoading && (
                <p className="empty-message">No audience matched against your Dynamic keywords!</p>
              )
            : null}

          {!searchPeopleMode && !dynamicPeopleMode ? (
            recommendedPeopleData.length > 0 ? (
              recommendedPeopleData?.map((contactItem: any) => (
                <PersonBadgeItem
                  key={contactItem.id}
                  email={contactItem.email}
                  contact_id={contactItem.id}
                  image={contactItem.thumbnail ? contactItem.thumbnail : ""}
                  personalityType={contactItem.personality_details.archetype}
                  userName={contactItem.name.trim() || contactItem.email.trim()}
                  pColor={contactItem.personality_details.color}
                  handleAddPeople={handleAddPeople}
                  // disabled={selectedContactIds?.indexOf(contactItem.id) >= 0 ? true : false}
                  added={addedContactIds?.indexOf(contactItem.id) >= 0 ? true : false}
                  selected={selectedContactIds?.indexOf(contactItem.id) >= 0}
                  // selected={selectedRecommendedContactsIds?.indexOf(Number(contactItem?.id)) >= 0}
                  organization={contactItem?.organization}
                  designation={contactItem?.designation}
                  status={contactItem?.status}
                  isBounced={contactItem?.status === "Hard Bounce" || contactItem?.status === "Unsubscribed"}
                  showTip
                  isRecommended
                />
              ))
            ) : !ContactsLoading ? (
              selectAllFlag && !audienceFiltersApplied && recommendedPeopleData.length === 0 ? (
                <p className="empty-message">All the recommended contacts are already added!</p>
              ) : (
                <p className="empty-message">
                  You haven’t published any campaign yet, system will recommend contacts here for campaign audience
                  based on users’ engagement.
                </p>
              )
            ) : null
          ) : null}

          {searchPeopleMode
            ? searchedPeopleData.length > 0
              ? searchedPeopleData?.map((contactItem: any) => (
                <PersonBadgeItem
                  key={`searched-${contactItem.id}`}
                  contact_id={contactItem.id}
                  email={contactItem.email}
                  image={contactItem.thumbnail ? contactItem.thumbnail : ""}
                  personalityType={contactItem.personality_details.archetype}
                  userName={contactItem.name.trim() || contactItem.email.trim()}
                  pColor={contactItem.personality_details.color}
                  handleAddPeople={handleAddPeople}
                  // disabled={selectedContactIds?.indexOf(contactItem.id) >= 0 ? true : false}
                  added={addedContactIds?.indexOf(contactItem.id) >= 0 ? true : false}
                  selected={selectedContactIds?.indexOf(contactItem.id) >= 0}
                  organization={contactItem?.organization}
                  designation={contactItem?.designation}
                  status={contactItem?.status}
                  isBounced={contactItem?.status === "Hard Bounce" || contactItem?.status === "Unsubscribed"}
                  showTip
                  isSearched
                />
              ))
              : !ContactsLoading && (
                <p>{peopleSearchSuccess ? "No audience found against your search!" : peopleSearchMessage}</p>
              )
            : null}
        </InfiniteLoader>
      </div>

      {!hideRecommendedList && (
        <>
          <div className="head-wrapper space-top">
            <h3 className="heading">
              Recommended List
              {!(recommendedListsLoading || listSearchLoading) ? ` (${totalCountLists()})` : <TotalCountLoader />}
            </h3>
            <span className="d-flex flex-nowrap">
              {/* <ButtonRightIcon
                label=""
                icon={Send}
                outlineClass="auto-width me-3"
                onClick={handleExportContacts}
              /> */}
              <div className="search-wrapper">
                <GenericSearch
                  handleSearch={(value: string) => {
                    searchHandler(value, "list");
                  }}
                  outerValue={searchTermLists}
                  handleClear={handleCancelListSearch}
                  placeholder="Search lists..."
                />
              </div>
            </span>
          </div>
          <div className="d-flex flex-nowrap select-row mb-3">
            {hideSelectAll ? null : (
              <>
                <label>
                  <Checkbox checked={selectAllLists} onChange={handleSelectAllLists} />
                  {selectAll ? `Unselect all` : `Select all`}
                </label>
                {selectedListIds?.length > 0 ? (
                  <div className="selected-count">
                    <Checkbox checked={true} readOnly />
                    <Checkbox checked={true} readOnly />
                    {selectedListIds?.length} lists selected
                  </div>
                ) : null}
              </>
            )}
          </div>
        </>
      )}
      {!hideRecommendedList &&
        searchListMode === false &&
        listSearchLoading === false &&
        recommendedListsLoading === false &&
        recommendedAudienceList.length === 0 ? (
        <p className="empty-message">
          System will recommend lists here to include in campaign audience based on users’ engagement once you
          published any campaign.
        </p>
      ) : searchListMode && listSearchResults.length === 0 && !listSearchLoading ? (
        <p>{listSearchSuccess ? "No results found against your search." : listSearchMessage}</p>
      ) : null}

      {!hideRecommendedList && (
        <>
          {recommendedListsLoading || listSearchLoading ? (
            <AssetsFourCardsPlaceHolder loading={recommendedListsLoading || listSearchLoading} />
          ) : null}
          <Carousel
            responsive={responsiveV}
            containerClass="carousel-container"
            renderButtonGroupOutside={true}
            arrows={true}
          >
            {!searchListMode &&
              !listSearchLoading &&
              !recommendedListsLoading &&
              recommendedAudienceList?.map((listItem, index) => (
                <div key={index} className="mx-2">
                  <ListCard
                    key={index}
                    classname={`list-card-sm ${selectedListIds?.indexOf(listItem.id) >= 0 ? "show-sselected" : ""
                      }`}
                    list={listItem}
                    isList={true}
                    showCheckbox={true}
                    handleAddPeople={handleAddPeople}
                    added={addedListIds.indexOf(listItem.id) >= 0 ? true : false}
                    selected={selectedListIds?.indexOf(listItem.id) >= 0}
                  />
                </div>
              ))}
          </Carousel>
          <Carousel
            responsive={responsiveV}
            containerClass="carousel-container"
            renderButtonGroupOutside={true}
            arrows={true}
          >
            {searchListMode &&
              !listSearchLoading &&
              !recommendedListsLoading &&
              listSearchResults?.map((listItem, index) => (
                <div key={index} className="mx-2">
                  <ListCard
                    key={index}
                    classname={`list-card-sm ${selectedListIds?.indexOf(listItem.id) >= 0 ? "show-sselected" : ""
                      }`}
                    list={listItem}
                    isList={true}
                    showCheckbox={true}
                    handleAddPeople={handleAddPeople}
                    selected={selectedListIds?.indexOf(listItem.id) >= 0}
                    added={addedListIds.indexOf(listItem.id) >= 0 ? true : false}
                  />
                </div>
              ))}
          </Carousel>
        </>
      )}
      {!inCreateNewList ? (
        <div className="footer-wrapper">
          <ButtonRightIconGreen
            icon={DoneGreen}
            label="Done"
            classBtn="done-btn"
            data-id="qa-btn-done"
            onClick={handleClickDone}
          />
        </div>
      ) : null}
    </Wrapper>
  );
};

export default PeopleAndList;

interface IWrapperProps {
  displayScroll?: any;
  disableMaxHeight?: boolean;
}

const Wrapper = styled("div") <IWrapperProps>`
  .inner-wrapper {
    width: 100% !important;
    margin-top: 0 !important;
  }
  .carousel-container {
    margin: 0 -8px;
    min-width: calc(100vw - 1270px);
    .react-multi-carousel-track {
      min-width: 100%;
    }
    .react-multi-carousel-item {
      flex: none !important;
    }
    .react-multiple-carousel__arrow {
      position: absolute;
      outline: 0;
      right: 20px;
      -webkit-transition: all 0.5s;
      transition: all 0.5s;
      border-radius: 35px;
      z-index: 10;
      border: 0;
      background: #fff;
      min-width: 43px;
      min-height: 43px;
      opacity: 1;
      cursor: pointer;
      box-shadow: 0 0 14px 5px rgb(0 0 0 / 10%);
      top: 30%;
      &.react-multiple-carousel__arrow--left {
        min-width: 43px;
        width: 43px;
        &::before {
          margin-left: -3px;
        }
      }
      &.react-multiple-carousel__arrow--right {
        min-width: 43px;
        width: 43px;
        &::before {
          margin-right: -4px;
        }
      }
      &::before {
        color: #424b50;
      }
    }
  }
  .footer-wrapper {
    padding: 20px 0px;
    display: flex;
    justify-content: flex-end;
    position: absolute;
    width: 100%;
    bottom: 10px;
    right: 24px;
    @media all and (max-width: 1200px) and (max-height: 660px) and (min-height: 600px) {
      bottom: -6px;
    }
    .done-btn {
      .icon {
        img {
          width: 14px;
        }
      }
    }
  }
  .contactsStyles {
    white-space: normal;
    div {
      div {
        svg {
          vertical-align: unset;
        }
      }
    }
  }
  .head-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: start !important;
    &.recommended-contacts-row {
      @media all and (max-width: 1200px) {
        flex-direction: column;
        justify-content: space-between;
      }
    }
    .other-side {
      @media all and (max-width: 1200px) {
        width: 100%;
        justify-content: flex-end;
      }
    }
    .heading {
      font-family: "Roboto Slab", serif;
      font-weight: 600;
      color: #424b50;
      font-size: 22px;
      margin-top: 0px;
      line-height: 30px;
      margin-bottom: 6px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 16px;
      }
    }
    .icon {
      margin: 4px 0px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        margin: 3px 0px;
      }
    }
    .search-wrapper {
      width: 175px;
    }
    &.space-top {
      margin-top: 30px;
      /* margin-bottom: 20px; */
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        margin-top: 15px;
        /* margin-bottom: 0px; */
      }
    }
  }
  .select-row {
    font-size: 12px;
    font-weight: 500;
    font-family: "Roboto", sans-serif;
    label {
      color: #7e7e7e;
      line-height: 18px;
      > div {
        margin-top: 0;
        height: 16px;
        overflow: hidden;
        /* background: #fff; */
        label span {
          padding: 0px;
          height: 16px;
          width: 16px;
        }
      }
    }
    .selected-count {
      color: #27ce0a;
      padding-left: 10px;
      margin-left: 10px;
      border-left: 1px solid #27ce0a;
      position: relative;
      line-height: 18px;
      > div {
        z-index: 1;
        position: relative;
        background: #fff;
        height: 16px;
        overflow: hidden;
        margin-top: 0;
        margin-right: 15px;
        pointer-events: none;
        label span {
          padding: 0px;
          height: 16px;
          width: 16px;
        }
      }
      > div + div {
        position: absolute;
        left: 14px;
        top: 3px;
        z-index: 0;
      }
    }
  }
  .recommended-people {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: flex-start;
    overflow-x: hidden;
    margin-top: 20px;
    scrollbar-width: thin;
    scrollbar-color: #001760 #efefef;
    overflow-y: hidden !important;
    .infinite-scroll-component {
       min-height: 200px;
       max-height: calc(100vh - 585px);
       overflow-y: auto !important;
        &::-webkit-scrollbar {
          width: 5px;
          height: 5px;
          border-radius: 5px;
        }
        /* Track */
        &::-webkit-scrollbar-track {
          background: #fff;
          margin-top: 10px;
          margin-bottom: 15px;
        }
        /* Handle */
        &::-webkit-scrollbar-thumb {
          background: #001760;
        }
        /* Handle on hover */
        &::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        max-height: calc(100vh - 475px);
        margin-top: 0px;
      }
    }

    &.full-height-users {
      .infinite-scroll-component { 
        height: calc(100vh - 180px);
        min-height: calc(100vh - 180px);
      }

    }
  }
  p {
    color: #424b50;
  }
  p.empty-message {
    font-weight: bold;
    font-size: 16px;
  }
  .info-icon{
    height: 16px;
    width: 16px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      height: 14px;
      width: 14px;
    }
  }
  .infoTooltip {
    margin-left:8px;
    cursor: pointer;
    z-index: 1;
    position: relative;
    img {
      width: 13px;
      margin-left: 3px;
      margin-right: 2px;
    }
  }
  .info-tooltip {
    width: 350px;
    background: transparent;
    border-radius: 15px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: 340px;
    }
    .ant-popover-content {
      .ant-popover-arrow {
        right: 3px;
        top: 5px;
        width: 15px;
        height: 15px;
        border-width: 7px;
        left: 91% !important;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          left: 67% !important;
        }
      }
      .ant-popover-inner {
        border-radius: 15px;
        .ant-popover-inner-content {
          padding: 16px 21px 16px 16px;
          color: #5E7079;
          font-size: 12px;
          font-weight: 500;
          font-style: normal;
          font-family: "Roboto";
          letter-spacing: -0.395062px;
          line-height: 14px;
          border-radius: 15px;
          box-shadow: 0px 2px 60px 0 rgb(0 0 0 / 28%);
        }
      }
    }
  }
`;

const ExportBtn = styled.span`
  height: 31px;
  width: 30px;
  margin-right: 20px;
  cursor: pointer;
  background: #ffffff;
  border: 0.946496px solid #dadada;
  border-radius: 7.75399px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    height: 23.5px;
  }
  .export-icon {
    width: 10px;
    margin-left: 2px;
  }
  &.disable {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
